import type { StandingOrders } from './StandingOrders';

export const base: StandingOrders = {
    enabled: true,
    _description: 'Enables Standing order form',
    handleLocalErrors: {
        enabled: false,
        _description: 'Enables to handle local server errors, uses country specific translation',
    },
    sweepOrders: {
        enabled: true,
        _description: 'Enables Sweep orders form',
    },
    useFocusPage: {
        enabled: false,
        _description: 'Enables focus page detail in standing orders',
    },
    bookingDateFetching: {
        enabled: false,
        _description: 'Enables fetching of booking date for Standing orders',
    },
    useTranslationForChannelId: {
        enabled: false,
        _description: 'Enables translated channelId labels in standing orders',
    },
    allowStopRegularExecutionsAfterDeath: {
        enabled: false,
        _description: 'Enables option to stop standing orders executions after death',
    },
    paymentServiceApiEngine: {
        enabled: false,
        _description: 'Enables Payment Service driven SOR instead of GAPI',
    },
};
